const ServiceType = Object.freeze({
  CROSS_TAB: 'CrossTab',
  DOCUMENT_FINGERPRINT_RETRIEVAL: 'DocumentFingerprintRetrieval',
  DOCUMENT_RETRIEVAL: 'DocumentRetrieval',
  INSIGHT_COUNT: 'InsightCount',
  METRIC_VALUE: 'MetricValue',
  MEASURE_METRIC_VALUE: 'MeasureMetricValue',
  SENTENCE_FINGERPRINT_RETRIEVAL: 'SentenceFingerprintRetrieval',
  NOD_SENTENCE_FINGERPRINT_RETRIEVAL: 'NodSentenceFingerprintRetrieval',
  SENTENCE_RETRIEVAL: 'SentenceRetrieval',
  SW_TOP_LINKS: 'SWTopLinks',
  SW_TOP_POST: 'SWTopPost',
  SW_MEDIA: 'SWMedia',
  AM_MEDIA: 'AMMedia',
  PAGINATION: 'Pagination',
  GEO_TAG_DOC_FINGERPRINT_RETRIEVAL: 'GeoTagDocFingerprintRetrieval',
  SIDE_BY_SIDE: 'SideBySide',
  RANDOM_SENTENCE_RETRIEVAL: 'RandomSentenceRetrieval',
  RANDOM_DOCUMENT_RETRIEVAL: 'RandomDocumentRetrieval',
  RETRIEVE_FIELD: 'RetrieveField',
  FACET_RETRIEVAL: 'FacetRetrieval',
  SW_PHOTO_CONCEPTS: 'SWPhotoConcepts'
})
export default ServiceType
export type ServiceTypeStrings = typeof ServiceType[keyof typeof ServiceType]
// RESERVE BELOW
